<template>
  <div class="section-wrapper publicClasses">
    <div>
      <h2 class="section-title">
        {{ $t("class {}", { className: "A1 - A2" }) }}
        <span class="tag is-rounded">{{ sprkrBoxesData.length }}</span>
      </h2>
      <van-skeleton title :row="5" v-if="sprkrBoxes.loading" />
      <Tiles :items="sprkrBoxesData" />
    </div>
  </div>
</template>

<script>
import Tiles from "@/components/Tiles";
import { mapState, mapActions } from "vuex";
export default {
  name: "Classes",
  components: { Tiles },
  computed: {
    ...mapState("vokabel", ["sprkrBoxes", "rooms"]),
    sprkrBoxesData() {
      const { sprkrBoxes } = this;
      if (sprkrBoxes.data && sprkrBoxes.data.results) {
        return sprkrBoxes.data.results;
      }
      return [];
    },
    roomsData() {
      const { rooms } = this;
      if (rooms.data && rooms.data.results) {
        return rooms.data.results;
      }
      return [];
    }
  },
  methods: {
    ...mapActions("vokabel", ["getSprkrBoxes", "getPublicClasses"]),
    imgsrc(image) {
      let baseStaticHost =
        process.env.NODE_ENV == "development"
          ? ""
          : "https://f002.backblazeb2.com/file/initial-images";
      return image ? `${baseStaticHost}/${image}` : "";
    }
  },
  mounted() {
    this.getSprkrBoxes();
    this.getPublicClasses();
  }
};
</script>

<style lang="scss" scoped>
.tile-img {
  width: 5em;
  height: auto;
  margin-top: 0.3em;
  margin-top: 0.3em;
  margin-right: 0.3em;
}
</style>
